import React, { useState, useEffect } from 'react';
import { Button } from '../../button';
import { Popover, PopoverContent, PopoverTrigger } from '../../popover';
import { X } from 'lucide-react';
import MagnifyingGlass from "../../../assets/icons/magnifying-glass-small-gray.svg";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../select';

interface RoleFilterProps {
    filterState: {
        filterKey: string;
        filter: any;
        setFilter: (filters: any) => void;
    };
    title: string;
    description?: string;
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
}

const PopoverRoleFilterComponent: React.FC<RoleFilterProps> = ({
    filterState,
    title,
    description,
    isOpen,
    onOpenChange
}) => {
    const [localRole, setLocalRole] = useState(filterState.filter[filterState.filterKey] || '');

    // Update local state when filter changes
    useEffect(() => {
        setLocalRole(filterState.filter[filterState.filterKey] || '');
    }, [filterState.filter, filterState.filterKey]);

    const handleRoleChange = (value: string) => {
        const actualValue = value === 'all' ? '' : value;
        setLocalRole(actualValue);
        filterState.setFilter({
            ...filterState.filter,
            [filterState.filterKey]: actualValue
        });
    };

    const handleClear = () => {
        setLocalRole('');
        filterState.setFilter({
            ...filterState.filter,
            [filterState.filterKey]: ''
        });
    };

    const hasActiveFilter = localRole && localRole.trim() !== '';

    const roleOptions = [
        { value: 'super_admin', label: 'Super Admin' },
        { value: 'admin', label: 'Admin' },
        { value: 'user', label: 'User' }
    ];

    return (
        <Popover open={isOpen} onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <img className="ml-2 w-3 cursor-pointer" src={MagnifyingGlass} alt="Search" />
            </PopoverTrigger>
            <PopoverContent className="w-80 p-4" align="start">
                <div className="space-y-4">
                    <div className="flex items-center justify-between">
                        <h4 className="font-medium text-sm">{title}</h4>
                        {hasActiveFilter && (
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={handleClear}
                                className="h-6 px-2 text-xs text-gray-500 hover:text-gray-700"
                            >
                                <X className="h-3 w-3 mr-1" />
                                Clear
                            </Button>
                        )}
                    </div>

                    <div>
                        <Select value={localRole || 'all'} onValueChange={handleRoleChange}>
                            <SelectTrigger className="w-full">
                                <SelectValue placeholder="Select role..." />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="all">All Roles</SelectItem>
                                {roleOptions.map((option) => (
                                    <SelectItem key={option.value} value={option.value}>
                                        {option.label}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>

                </div>
            </PopoverContent>
        </Popover>
    );
};

export default PopoverRoleFilterComponent;
